import React from 'react';
import Menu from '../components/menu/Menu';
import Footer from '../components/footer/Footer';
import Profile from '../components/profile/Profile';
import store from '../store/Store';
import { initialState as loginState } from '../reducers/loginReducer';
import { initialState as userState } from '../reducers/userReducer';
import './developView.scss';

type developState = {

}

type developProps = {
	login: {
		loggedIn
	},
	user: {
		id,
		title,
		name,
		lastName,
		gender,
		email,
		password,
		admin
	}
}

class DevelopView extends React.Component<developState, developProps> {

	constructor(props) {
		super(props)

		this.state = {
			login: {
				loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
			},
			user: {
				id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
				title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
				name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
				lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
				gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
				email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
				password: store.getState().user && store.getState().user.password ? store.getState().user.password : '',
        		admin: store.getState().user && store.getState().user.admin ? store.getState().user.admin : false
			}
		}

		store.subscribe(() => {
			this.setState({
				login: {
					loggedIn: store.getState().login && store.getState().login.loggedIn ? store.getState().login.loggedIn : false
				},
				user: {
					id: store.getState().user && store.getState().user.id ? store.getState().user.id : 0,
					title: store.getState().user && store.getState().user.title ? store.getState().user.title : '',
					name: store.getState().user && store.getState().user.name ? store.getState().user.name : '',
					lastName: store.getState().user && store.getState().user.lastName ? store.getState().user.lastName : '',
					gender: store.getState().user && store.getState().user.gender ? store.getState().user.gender : -1,
					email: store.getState().user && store.getState().user.email ? store.getState().user.email : '',
					password: store.getState().user && store.getState().user.password ? store.getState().user.password : '',
        			admin: store.getState().user && store.getState().user.admin ? store.getState().user.admin : false
				}
			})
		})
	}

	componentDidMount() {
		
	}

	render() {
		const { login, user } = this.state;

		return (
			<div className="DevelopView">
				<Menu login={login} user={user} />
				<Profile login={login} user={user} />
				<Footer />
			</div>
		);
	}
}

export default DevelopView;
